(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive"]) return;
  try {
     
$('a:contains("Events")').parent('li').addClass('active');


function storeid(){
    var divName = document.getElementsByClassName('pullup');
	var className = document.getElementsByClassName('date');
	var locName = document.getElementsByClassName('location');
	var ageHigh = document.getElementsByClassName('ageHigh');
	var ageLow = document.getElementsByClassName('ageLow');
    var classnameCount = className.length;
    var IdStore = new Array();
	
    for(var j = 0; j < classnameCount; j++){
		var obj = {};
		var div = divName[j];
		var dateString = className[j].innerText; 
		var locationString = locName[j].innerText; 
		var ageHString = ageHigh[j].innerText;
		var ageLString = ageLow[j].innerText; 
                                      
		obj["div"] = div;
		obj ["date"] = dateString; 
		obj ["location"] = locationString;
		obj ["ageHigh"] = ageHString; 
		obj ["ageLow"] = ageLString;                                      
        IdStore.push(obj);
    }
  console.log(IdStore);
  IdStore = IdStore.sort(function(a,b){
  return b.date - a.date });
                                      
IdStore.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})

}

storeid();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-template"]) return;
  try {
    
function storeid(){
    var divName = document.getElementsByClassName('pullup');
	var className = document.getElementsByClassName('date');
	var locName = document.getElementsByClassName('location');
	var ageHigh = document.getElementsByClassName('ageHigh');
	var ageLow = document.getElementsByClassName('ageLow');
    var classnameCount = className.length;
    var IdStore = new Array();
	
    for(var j = 0; j < classnameCount; j++){
		var obj = {};
		var div = divName[j];
		var dateString = className[j].innerText; 
		var locationString = locName[j].innerText; 
		var ageHString = ageHigh[j].innerText;
		var ageLString = ageLow[j].innerText; 
                                      
		obj["div"] = div;
		obj ["date"] = dateString; 
		obj ["location"] = locationString;
		obj ["ageHigh"] = ageHString; 
		obj ["ageLow"] = ageLString;                                      
        IdStore.push(obj);
    }
  IdStore = IdStore.sort(function(a,b){
  return a.date - b.date  });
                                     
  function removeEvents() {
         var myNode = document.getElementById("attach");
        while (myNode.firstChild) {
            myNode.removeChild(myNode.firstChild);
        }
    }


if (IdStore === undefined || IdStore.length == 0) {
	var h1 = document.createElement("h1");
	var node = document.createTextNode("There are no upcoming events at this time");
	h1.appendChild(node);
	var element = document.getElementById('attach');
	element.appendChild(h1);
} else {

IdStore.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})
}


var filterArticles = IdStore; 
var slider = document.getElementById("myRange");
var select = document.getElementById("select");
var output = document.getElementById("demo");


$(document).on('change', 'select', function() {
	$('#reset').removeClass('deactive');
	removeEvents();
	 $('#reset').removeClass('deactive');

      var location = $('#select').val();
	  var age = slider.value;	

var location = $('#select').val();
	  var age = slider.value;		
     if(location === 'All' || location === '') {
var res = IdStore.filter(function(o) {
  // check value is within the range
  // remove `=` if you don't want to include the range boundary
  return slider.value == 0 || parseInt(o.ageLow) <= slider.value && parseInt(o.ageHigh) >= slider.value;
});

res.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})
        		
    } else {
var res = IdStore.filter(function(o) {
  // check value is within the range
  // remove `=` if you don't want to include the range boundary
  return slider.value == 0 || parseInt(o.ageLow) <= slider.value && parseInt(o.ageHigh) >= slider.value;
});

var full = res.filter(a => a.location === location);
full.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})
	
		
    }

		checkLength();

});


slider.oninput = function() {
removeEvents();
$('#reset').removeClass('deactive');
var  age = slider.value;
var location = $('#select').val();

if (slider.value == 0) {
        output.innerHTML = "All Ages";

    } else {
        output.innerHTML = "Age " + this.value;
		document.getElementById("change").innerHTML = "Age " + this.value;
}

var res = IdStore.filter(function(o) {
  // check value is within the range
  // remove `=` if you don't want to include the range boundary
  return slider.value == 0 || parseInt(o.ageLow) <= slider.value && parseInt(o.ageHigh) >= slider.value;
});

if(location === 'All' || location === '') { 
res.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})

} else {

var full = res.filter(a => a.location === location);
full.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})

}

checkLength();


}

    function checkLength() {
if( !$.trim( $('#attach').html() ).length ) {
                   var h1 = document.createElement("h1");
                    var node = document.createTextNode("No events fit this search");
                    h1.appendChild(node);

                    var element = document.getElementById("attach");
                    element.appendChild(h1);

	} else {


} 

}


$('.dropbtn').mousedown(function(e) 
{
   var container = $(".dropbtn");
	    if (container.is(e.target)) 
    {
        $('.dropdown-content').addClass('dropdown-display-block');
    }

});

<!-- keyboard support -->

$('.dropbtn').keydown(function(e){
    var keycode = (e.keyCode ? e.keyCode : e.which);
	var container = $(".dropbtn");
    if(keycode == '13') {
		$('.dropdown-content').addClass('dropdown-display-block');
		$('.dropbtn').attr('aria-expanded', 'true');
    }
});

$(document).mouseup(function(e) 
{    var container = $(".dropdown");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $('.dropdown-content').removeClass('dropdown-display-block');
    }
});

document.getElementById('reset').onclick = function(){
   removeEvents();
   slider.value = 0;
	output.innerHTML = "All Ages";
   var age = slider.value;
    $('#reset').addClass('deactive');
   document.getElementById('select').value = "";
		document.getElementById("change").innerHTML = "All Ages" 
	IdStore.forEach(el => {
  document.getElementById("attach").appendChild(el.div);
})	
	

};



}

storeid();
                            


                                      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-hours"] && !Shopify.designMode) return;
  try {
    
var da = new Date();





//gets the current time. 
//var d = new Date();
var x = document.getElementsByClassName("start")[0].innerText;
var z = document.getElementsByClassName("end")[0].innerText;

var y = document.getElementsByClassName("sun-start")[0].innerText;
var w = document.getElementsByClassName("sun-end")[0].innerText;




if(Date.today().is().sunday()) {

var startTime = Date.parseExact(y, "h:mmtt");
var endTime = Date.parseExact(w, "h:mmtt");


if (da.between(startTime, endTime)){
    $(".open").show();
    $(".closed").hide();
}
else {  
    $(".closed").show();
    $(".open").hide();
}

} else {

var startTime = Date.parseExact(x, "h:mmtt");
var endTime = Date.parseExact(z, "h:mmtt");


if (da.between(startTime, endTime)){
    $(".open").show();
    $(".closed").hide();
}
else {  
    $(".closed").show();
    $(".open").hide();
}
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$( document ).ready(function() {
if ($('#globo-recommendations').contents().length > 0) {
	console.log('true');
} else {
	console.log('false');

}
});



  } catch(e) { console.error(e); }
})();
})();
